import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _57e02bc3 = () => interopDefault(import('..\\pages\\access-your-card.vue' /* webpackChunkName: "pages_access-your-card" */))
const _6d0c6a32 = () => interopDefault(import('..\\pages\\card-print.vue' /* webpackChunkName: "pages_card-print" */))
const _11a38fa9 = () => interopDefault(import('..\\pages\\cookie-policy.vue' /* webpackChunkName: "pages_cookie-policy" */))
const _7b057132 = () => interopDefault(import('..\\pages\\program-requirements\\index.vue' /* webpackChunkName: "pages_program-requirements_index" */))
const _58dc70c8 = () => interopDefault(import('..\\pages\\rebate-form.vue' /* webpackChunkName: "pages_rebate-form" */))
const _60672ec6 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _0dd3c0a9 = () => interopDefault(import('..\\pages\\view-your-account.vue' /* webpackChunkName: "pages_view-your-account" */))
const _72e73ad2 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _72cb0bd0 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _7292adcc = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _72767eca = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _091ac450 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _237d807c = () => interopDefault(import('..\\pages\\program-requirements\\imaavy.vue' /* webpackChunkName: "pages_program-requirements_imaavy" */))
const _3b9a3464 = () => interopDefault(import('..\\pages\\program-requirements\\inlexzo.vue' /* webpackChunkName: "pages_program-requirements_inlexzo" */))
const _cf602e34 = () => interopDefault(import('..\\pages\\program-requirements\\mm1.vue' /* webpackChunkName: "pages_program-requirements_mm1" */))
const _5ee8724f = () => interopDefault(import('..\\pages\\program-requirements\\program-requirement.vue' /* webpackChunkName: "pages_program-requirements_program-requirement" */))
const _732ec32e = () => interopDefault(import('..\\pages\\program-requirements\\remicade.vue' /* webpackChunkName: "pages_program-requirements_remicade" */))
const _189cd298 = () => interopDefault(import('..\\pages\\program-requirements\\rybrevant.vue' /* webpackChunkName: "pages_program-requirements_rybrevant" */))
const _7ca1c262 = () => interopDefault(import('..\\pages\\program-requirements\\simponiAria.vue' /* webpackChunkName: "pages_program-requirements_simponiAria" */))
const _7f20b246 = () => interopDefault(import('..\\pages\\program-requirements\\stelara.vue' /* webpackChunkName: "pages_program-requirements_stelara" */))
const _ff6d4e46 = () => interopDefault(import('..\\pages\\program-requirements\\stelara-standard.vue' /* webpackChunkName: "pages_program-requirements_stelara-standard" */))
const _0bccf246 = () => interopDefault(import('..\\pages\\program-requirements\\tremfya-standard.vue' /* webpackChunkName: "pages_program-requirements_tremfya-standard" */))
const _67628380 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/access-your-card",
    component: _57e02bc3,
    name: "access-your-card"
  }, {
    path: "/card-print",
    component: _6d0c6a32,
    name: "card-print"
  }, {
    path: "/cookie-policy",
    component: _11a38fa9,
    name: "cookie-policy"
  }, {
    path: "/program-requirements",
    component: _7b057132,
    name: "program-requirements"
  }, {
    path: "/rebate-form",
    component: _58dc70c8,
    name: "rebate-form"
  }, {
    path: "/unlock",
    component: _60672ec6,
    name: "unlock"
  }, {
    path: "/view-your-account",
    component: _0dd3c0a9,
    name: "view-your-account"
  }, {
    path: "/errors/400",
    component: _72e73ad2,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _72cb0bd0,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _7292adcc,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _72767eca,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _091ac450,
    name: "errors-500"
  }, {
    path: "/program-requirements/imaavy",
    component: _237d807c,
    name: "program-requirements-imaavy"
  }, {
    path: "/program-requirements/inlexzo",
    component: _3b9a3464,
    name: "program-requirements-inlexzo"
  }, {
    path: "/program-requirements/mm1",
    component: _cf602e34,
    name: "program-requirements-mm1"
  }, {
    path: "/program-requirements/program-requirement",
    component: _5ee8724f,
    name: "program-requirements-program-requirement"
  }, {
    path: "/program-requirements/remicade",
    component: _732ec32e,
    name: "program-requirements-remicade"
  }, {
    path: "/program-requirements/rybrevant",
    component: _189cd298,
    name: "program-requirements-rybrevant"
  }, {
    path: "/program-requirements/simponiAria",
    component: _7ca1c262,
    name: "program-requirements-simponiAria"
  }, {
    path: "/program-requirements/stelara",
    component: _7f20b246,
    name: "program-requirements-stelara"
  }, {
    path: "/program-requirements/stelara-standard",
    component: _ff6d4e46,
    name: "program-requirements-stelara-standard"
  }, {
    path: "/program-requirements/tremfya-standard",
    component: _0bccf246,
    name: "program-requirements-tremfya-standard"
  }, {
    path: "/",
    component: _67628380,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
